export const config = {
  wssEndpoint: process.env.REACT_APP_BACKEND_WS_URL,
  httpEndpoint: process.env.REACT_APP_BACKEND_HTTP_URL
}